import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);

export default function initGsapAnimation() {
  homeanime();
}

function syncMvSliderAspect() {
  const sliders = gsap.utils.toArray(".hm-mv-slider");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const mainImg = slider.querySelector(".splide__slide img:first-of-type");
    const bgImg = slider.querySelector(".splide__slide img:last-of-type");
    if (!mainImg) return;

    const apply = () => {
      if (mainImg.naturalWidth > 0) {
        slider.style.setProperty(
          "--mv-aspect-ratio",
          `${mainImg.naturalWidth} / ${mainImg.naturalHeight}`,
        );
      }
      if (bgImg?.src) {
        slider.style.setProperty(
          "--mv-after-bg",
          `url("${bgImg.currentSrc || bgImg.src}")`,
        );
      }
      ScrollTrigger.refresh();
    };

    if (mainImg.complete && mainImg.naturalWidth > 0) {
      apply();
      return;
    }

    mainImg.addEventListener("load", apply, { once: true });
    mainImg.addEventListener("error", () => ScrollTrigger.refresh(), {
      once: true,
    });
  });
}

function homeanime() {
  // クラス配列まとめ
  const fadeItems = gsap.utils.toArray(".gsap-fade-item");
  const fadeItemsTwo = gsap.utils.toArray(".gsap-fade-item-two");
  const zoomItems = gsap.utils.toArray(".gsap-zoom");
  const gsapMasks = gsap.utils.toArray(".gsap-mask");
  const gsapMasksBottom = gsap.utils.toArray(".gsap-mask-bottom");
  const gsapFadeBg = gsap.utils.toArray(".gsap-fade-bg");

  // gsap-fade-item がなければ処理ストップ
  if (fadeItems.length === 0 && fadeItemsTwo.length === 0) return;

  syncMvSliderAspect();

  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": function () {
      // Timeline1: hm-mv
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".hm-mv",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      // 1. gsap-fade-item の疑似要素順番（左→中央→右）
      ["--left", "--center", "--right"].forEach((cls) => {
        const el = fadeItems.find((item) => item.classList.contains(cls));
        if (el) {
          tl.to(el, {
            duration: 0.5,
            "--after-opacity": 1,
          });
        }
      });

      // 2. splide__track を同時fade-in
      const splideTracks = gsap.utils.toArray(".gsap-fade-item .hm-mv-banner");
      if (splideTracks.length > 0) {
        tl.to(splideTracks, { autoAlpha: 1, duration: 0.8, stagger: 0 });
      }

      tl.to(
        fadeItems,
        {
          duration: 0.4,
          "--after-opacity": 0,
        },
        "<",
      );

      // 3. gsap-fade-item-two を同時fade-in
      if (fadeItemsTwo.length > 0) {
        tl.to(fadeItemsTwo, { autoAlpha: 1, duration: 0.8, stagger: 0 });
      }

      // Timeline2: hm-about
      if (zoomItems.length > 0 || gsapMasks.length > 0) {
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: ".hm-about",
            start: "top 50%",
          },
        });

        if (gsapMasks.length > 0) {
          tl2.to(gsapMasks[0], {
            duration: 1,
            ease: "power2.out",
            webkitMaskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
            maskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
          });
        }

        // gsap-zoom
        if (zoomItems.length > 0) {
          tl2.to(zoomItems, {
            maskSize: "100% 100%",
            ease: "power2.out",
            duration: 1,
          });
        }

        if (gsapFadeBg.length > 0) {
          tl2.to(
            gsapFadeBg,
            {
              "--bg-opacity": 1,
              duration: 2,
              ease: "power2.out",
            },
            "<",
          );
        }

        // gsap-mask
        if (gsapMasks.length > 0) {
          tl2.to(
            gsapMasks[1],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
            },
            "<0.2",
          );
        }
      }

      // Timeline3: hm-business
      if (gsapMasks.length > 0) {
        const tl3 = gsap.timeline({
          scrollTrigger: {
            trigger: ".hm-business",
            start: "top 80%",
            // markers: true,
          },
        });

        // gsap-mask
        if (gsapMasks.length > 0) {
          tl3.to(gsapMasks[2], {
            duration: 1,
            ease: "power2.out",
            webkitMaskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
            maskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
          });
        }
      }
      if (gsapMasksBottom.length > 0) {
        const tl4 = gsap.timeline({
          scrollTrigger: {
            trigger: ".hm-business-card",
            start: "top 70%",
            // markers: true,
          },
        });

        if (gsapMasksBottom.length > 0) {
          tl4.to(
            [
              gsapMasksBottom[0],
              gsapMasksBottom[3],
              gsapMasksBottom[6],
              gsapMasksBottom[9],
              gsapMasksBottom[12],
            ],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
            },
          );
        }
        if (gsapMasksBottom.length > 0) {
          tl4.to(
            [
              gsapMasksBottom[1],
              gsapMasksBottom[2],
              gsapMasksBottom[4],
              gsapMasksBottom[5],
              gsapMasksBottom[7],
              gsapMasksBottom[8],
              gsapMasksBottom[10],
              gsapMasksBottom[11],
              gsapMasksBottom[13],
              gsapMasksBottom[14],
            ],
            {
              duration: 2,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
            },
            "<0.5",
          );
        }
      }
    },
    "(max-width: 1024px)": function () {
      // Timeline1: hm-mv
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".hm-mv",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      // 1. gsap-fade-item の疑似要素順番（左→中央→右）
      ["--left", "--center", "--right"].forEach((cls) => {
        const el = fadeItems.find((item) => item.classList.contains(cls));
        if (el) {
          tl.to(el, {
            duration: 0.5,
            "--after-opacity": 1,
          });
        }
      });

      // 2. splide__track を同時fade-in
      const splideTracks = gsap.utils.toArray(".gsap-fade-item .hm-mv-banner");
      if (splideTracks.length > 0) {
        tl.to(splideTracks, { autoAlpha: 1, duration: 0.8, stagger: 0 });
      }

      tl.to(
        fadeItems,
        {
          duration: 0.4,
          "--after-opacity": 0,
        },
        "<",
      );

      // 3. gsap-fade-item-two を同時fade-in
      if (fadeItemsTwo.length > 0) {
        tl.to(fadeItemsTwo, { autoAlpha: 1, duration: 0.8, stagger: 0 });
      }

      // Timeline2: hm-about
      if (zoomItems.length > 0 || gsapMasks.length > 0) {
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: ".hm-about",
            start: "top 50%",
          },
        });

        if (gsapMasks.length > 0) {
          gsap.to(gsapMasks[0], {
            duration: 1,
            ease: "power2.out",
            webkitMaskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
            maskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
            scrollTrigger: {
              trigger: gsapMasks[0], // 自分の要素をトリガーに
              start: "top 80%", // ビューポート上部から80%で発火
            },
          });
        }

        // gsap-zoom
        if (zoomItems.length > 0) {
          gsap.to(zoomItems[0], {
            maskSize: "100% 100%",
            ease: "power2.out",
            duration: 1,
            scrollTrigger: {
              trigger: zoomItems[0], // 自分の要素をトリガーに
              start: "top 80%", // ビューポート上部から80%で発火
            },
          });
        }

        if (gsapFadeBg.length > 0) {
          tl2.to(
            gsapFadeBg,
            {
              "--bg-opacity": 1,
              duration: 2,
              ease: "power2.out",
            },
            "<",
          );
        }

        // gsap-mask
        if (gsapMasks.length > 0) {
          gsap.to(
            gsapMasks[1],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
              scrollTrigger: {
                trigger: gsapMasks[1], // 自分の要素をトリガーに
                start: "top 80%", // ビューポート上部から80%で発火
              },
            },
            "<0.2",
          );
        }

        // gsap-zoom
        if (zoomItems.length > 0) {
          gsap.to(zoomItems[1], {
            maskSize: "100% 100%",
            ease: "power2.out",
            duration: 1,
            scrollTrigger: {
              trigger: zoomItems[1], // 自分の要素をトリガーに
              start: "top 80%", // ビューポート上部から80%で発火
            },
          });
          gsap.to(
            zoomItems[2],
            {
              maskSize: "100% 100%",
              ease: "power2.out",
              duration: 1,
              scrollTrigger: {
                trigger: zoomItems[2], // 自分の要素をトリガーに
                start: "top 80%", // ビューポート上部から80%で発火
              },
            },
            ">",
          );
        }
      }

      // Timeline3: hm-business
      if (gsapMasks.length > 0) {
        const tl3 = gsap.timeline({
          scrollTrigger: {
            trigger: ".hm-business",
            start: "top 80%",
            // markers: true,
          },
        });

        // gsap-mask
        if (gsapMasks.length > 0) {
          tl3.to(gsapMasks[2], {
            duration: 1,
            ease: "power2.out",
            webkitMaskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
            maskImage:
              "linear-gradient(to right, black 100%, black 100%, transparent 100%)",
          });
        }
      }
      if (gsapMasksBottom.length > 0) {
        const tl4 = gsap.timeline({
          scrollTrigger: {
            trigger: ".hm-business-card",
            start: "top 70%",
            // markers: true,
          },
        });

        if (gsapMasksBottom.length > 0) {
          gsap.to(
            [gsapMasksBottom[0], gsapMasksBottom[1], gsapMasksBottom[2]],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              scrollTrigger: {
                trigger: gsapMasksBottom[0], // 自分の要素をトリガーに
                start: "top 70%", // ビューポート上部から80%で発火
              },
            },
          );
        }
        if (gsapMasksBottom.length > 0) {
          gsap.to(
            [gsapMasksBottom[3], gsapMasksBottom[4], gsapMasksBottom[5]],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              scrollTrigger: {
                trigger: gsapMasksBottom[3], // 自分の要素をトリガーに
                start: "top 70%", // ビューポート上部から80%で発火
              },
            },
          );
        }
        if (gsapMasksBottom.length > 0) {
          gsap.to(
            [gsapMasksBottom[6], gsapMasksBottom[7], gsapMasksBottom[8]],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              scrollTrigger: {
                trigger: gsapMasksBottom[6], // 自分の要素をトリガーに
                start: "top 70%", // ビューポート上部から80%で発火
              },
            },
          );
        }
        if (gsapMasksBottom.length > 0) {
          gsap.to(
            [gsapMasksBottom[9], gsapMasksBottom[10], gsapMasksBottom[11]],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              scrollTrigger: {
                trigger: gsapMasksBottom[9], // 自分の要素をトリガーに
                start: "top 70%", // ビューポート上部から80%で発火
              },
            },
          );
        }
        if (gsapMasksBottom.length > 0) {
          gsap.to(
            [gsapMasksBottom[12], gsapMasksBottom[13], gsapMasksBottom[14]],
            {
              duration: 1,
              ease: "power2.out",
              webkitMaskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              maskImage:
                "linear-gradient(to top, black 100%, black 100%, transparent 100%)",
              scrollTrigger: {
                trigger: gsapMasksBottom[12], // 自分の要素をトリガーに
                start: "top 70%", // ビューポート上部から80%で発火
              },
            },
          );
        }
      }
    },
    // all
    all: function () {},
  });
}
